import {takeEvery} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeEvery(ACTION.UPDATE_SHIPPING_BILL.REQUEST, saga.updateShippingBill);
    yield takeEvery(ACTION.UPDATE_SHIPPING_BILL.SUCCESS, saga.onUpdateShippingBillSuccess);
    yield takeEvery(ACTION.UPDATE_SHIPPING_BILL.FAILED, saga.onUpdateShippingBillFailed);
}